// material
import { useTheme } from "@mui/material/styles";

import { Box, Avatar, useMediaQuery, Container, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { Link } from "react-scroll";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import { motion } from "framer-motion";
import { Link as RouterLink } from "react-router-dom";
import {
  NavbarLink,
  ToolbarStyle,
  StackStyle,
  AppBarStyle,
} from "../../styles/NavStyles";
import { AfriqualeosTitle, MyButton } from "../../styles/HomeStyles";

// ----------------------------------------------------------------------

export default function Navbar() {
  const [value, setValue] = useState("one");
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("sm"));

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <AppBarStyle
      component={motion.div}
      initial={{ opacity: 1, y: -100 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ type: "spring", stiffness: 120, delay: 0.5 }}
    >
      <Container maxWidth="lg">
        <ToolbarStyle>
          <Box to="/" component={RouterLink} sx={{ textDecoration: "none" }}>
            <Stack
              direction="row"
              alignItems="center"
              sx={{ cursor: "pointer" }}
            >
              <Avatar
                sx={{
                  background: "none",
                  color: (theme) => theme.palette.primary.light,
                  width: 50,
                  height: 50,
                }}
                alt="Afriqualeos"
                //src="./static/svg/Logo/logo-small.svg"
                component={motion.div}
                initial={{ rotate: 0 }}
                animate={{ rotate: 360 }}
                transition={{ delay: 0.3, type: "spring", stiffness: 40 }}
              >
                {/* <FingerprintIcon
                  sx={{
                    width: 30,
                    height: 30,
                  }}
                /> */}
                <img
                  style={{ width: "80%" }}
                  src="./static/svg/Logo/logo.svg"
                />
              </Avatar>
              <AfriqualeosTitle variant="h6">AFRIQUALEOS</AfriqualeosTitle>
            </Stack>
          </Box>

          {/* {matches ? (
            <>
              <StackStyle
                flexGrow="1"
                direction="row"
                justifyContent="center"
                sx={{ fontWeight: "bold" }}
              >
                <NavbarLink to="nous" smooth spy activeClass="active">
                  Qui Sommes Nous
                </NavbarLink>
                <NavbarLink to="mot_directeur" smooth spy activeClass="active">
                  Mot du directeur
                </NavbarLink>
                <NavbarLink to="nos_metiers" smooth spy activeClass="active">
                  Nos Métiers
                </NavbarLink>
              </StackStyle>
              <MyButton
                component={RouterLink}
                to="/formulaire"
                variant="contained"
              >
                Nos Services
              </MyButton>
            </>
          ) : (
            <>
              <Box sx={{ flexGrow: 1 }} />
              <AccountPopover />
            </>
          )} */}
        </ToolbarStyle>
      </Container>
    </AppBarStyle>
  );
}
